import { TModules } from 'pro/interfaces/product';
import { SPECIFICATIONS } from 'pro/config/pdfs';

export const MODULES: TModules = [
    {
        type: 'banner',
        picture: {
            src: 'asset/width-3839/picture/364c928d1f00c215429371ad61737e89.jpg',
            width: 1920,
            height: 1009,
        },
        text: {
            top: 573,
            slogan: 'ADVANCED GROW LIGHTING',
            name: '1000W PRO'
        }
    },
    {
        type: 'presentation',
        title: '1000W PRO FEATURE SUMMARY',
        picture: {
            src: 'asset/width-2030/picture/0003552d987a23a98aa880f6f24fd19d.jpg',
            width: 1008,
            height: 425,
        },
        data: {
            spectrum: 'FULL-SPECTRUM',
            efficacy: 'HIGH EFFICACY',
            heat: 'EXCELLENT HEAT DISSIPATION',
            stage: 'SUITABLE FOR ALL STAGES OF GROWTH',
        }
    },
    {
        type: 'features',
        title: 'key feature',
        list: [
            {
                title: 'PPFD & Light Uniformity',
                picture: {
                    src: 'asset/width-3086/picture/dd7d06fff8adbcb338f86878f2aa619a.jpg',
                    width: 1540,
                    height: 546,
                },
            },
            {
                title: 'Spectrum and Diodes',
                picture: {
                    src: 'asset/width-3086/picture/9430877c250bb586a2995b951aacef7d.jpg',
                    width: 1540,
                    height: 394,
                },
            },
            {
                title: 'Efficacy and Operation Cost',
                picture: {
                    src: 'asset/width-3080/picture/3978f3c47869d9dae18e228ab0473851.jpg',
                    width: 1540,
                    height: 535,
                },
            },
        ]
    },
    {
        type: 'pictures',
        title: 'CULTIVATOR SPOTLIGHT',
        list: [
            {
                src: 'asset/width-3080/picture/c9d678b031a416b04014b3f4bbc8f355.jpg',
                width: 1540,
                height: 830,
            },
        ],
    },
    {
        ...SPECIFICATIONS['1000W-PRO-LED'],
        type: 'spec',
        title: 'Specifications',
        picture: {
            src: 'asset/width-1378/picture/0419a3250c8c875da939655179796943.jpg',
            width: 674,
            height: 474,
        },
        list: [
            { name: 'Product Dimensions', value: '66.2"×47.6"×4.1"' },
            { name: 'Packaging Dimensions', value: '51.2"×40.9"×4.9"' },
            { name: 'G.W./N.W.', value: '48.5/40.1LBS' },
            { name: 'Input Voltage', value: '120V / 208V / 240V / 277V' },
            { name: 'Input Current', value: '8.33A / 4.81A / 4.17A / 3.61A' },
        ],
    },
    {
        type: 'otherFeatures',
        title: 'Other features',
        list: [
            {
                picture: 'asset/width-976/picture/497d1811c0dbf45125f4cce337ccabba.jpg',
                title: 'Global Control',
                desc: 'Control 160 lights simultaneously',
            },
            {
                picture: 'asset/width-976/picture/12387c4226781604e1f12ac3bcbe5895.jpg',
                title: 'Expanded Lifespan',
                desc: 'L90: > 54,000 hours',
            },
            {
                picture: 'asset/width-976/picture/c0f77a77e20f95c922214cd983ac8168.jpg',
                title: 'IP66-Rated',
                desc: 'High water and humidity resistance',
            },
        ]
    },
];